
/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param children jsx: Components to be rendered in the content
 *
 */
const ContainerValidation = ({ children }) => {

    return (
        <div className="identity-validation-external-container">
            {children}
        </div>
    )
}

export default ContainerValidation
